import nextArrowSVG from '../../assets/icons/arrow-next.svg'
import prevArrowSVG from '../../assets/icons/arrow-prev.svg'

export const NextArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{ ...style, display: 'block' }}
    onClick={onClick}
  >
    <img src={nextArrowSVG} alt="next" />
  </div>
)

export const PrevArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{ ...style, display: 'block' }}
    onClick={onClick}
  >
    <img src={prevArrowSVG} alt="prev" />
  </div>
)
